const faqs = [
  {
    q: '51吃瓜网是什么？',
    a: '51吃瓜网是国内领先的娱乐八卦资讯聚合平台，专注于收集、整理和发布全网最快最全的网红事件、明星八卦、黑料网曝等热门内容，是吃瓜群众获取第一手娱乐资讯的首选平台。',
  },
  {
    q: '51吃瓜网的内容来源可靠吗？',
    a: '我们的内容团队7×24小时监控全网社交媒体、论坛、短视频平台等渠道，汇聚多方信息源交叉验证。所有爆料内容均标注来源，力求为吃瓜群众提供最真实、最及时的瓜情动态。',
  },
  {
    q: '如何在51吃瓜网上投稿爆料？',
    a: '欢迎通过本站"爆料投稿"专区提交你的独家爆料。只需填写相关信息和素材，我们的编辑团队会在24小时内审核处理。优质独家爆料一经采用，将给予丰厚奖励。',
  },
  {
    q: '51吃瓜网APP有什么特色功能？',
    a: '51吃瓜网APP支持实时推送、离线阅读、夜间模式、话题订阅等特色功能。开启推送通知后，重大爆料第一时间送达你的手机，让你永远走在吃瓜第一线，不会错过任何精彩内容。',
  },
  {
    q: '51吃瓜网如何保证内容质量？',
    a: '我们拥有专业的编辑团队和严格的审核流程，所有发布内容均经过人工审核把关。同时采用智能推荐算法，根据用户阅读偏好个性化推送，确保每位吃瓜群众都能看到自己最关心的内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">吃瓜指南</h2>
          <p className="text-sm text-foreground-500 mt-3">关于51吃瓜网，你想知道的都在这里</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {faqs.slice(0, 3).map((faq, i) => (
            <div key={i} className="bg-background-50 border border-background-200/70 rounded-2xl p-6 hover:border-accent-300 transition-all duration-300">
              <h3 className="font-heading text-lg text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-accent-500 text-xl flex-shrink-0 mt-0.5">Q</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">{faq.a}</p>
            </div>
          ))}
          {faqs.slice(3).map((faq, i) => (
            <div key={i + 3} className="bg-background-50 border border-background-200/70 rounded-2xl p-6 hover:border-accent-300 transition-all duration-300">
              <h3 className="font-heading text-lg text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-accent-500 text-xl flex-shrink-0 mt-0.5">Q</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}